// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Euro,
    EvCharger,
    Expand,
    ExternalLink,
    Eye,
    EyeClosed,
    EyeDashed,
    EyeOff,
    FaceAngry,
    FaceExpressionless,
    FaceGrinning,
    FaceNeutral,
    FaceSlightlyFrowning,
    FaceSlightlySmiling,
    FaceSlightlySmilingPlus,
    Factory,
    Fan,
    FastForward,
    Feather,
    Fence,
    FerrisWheel,
    File,
    FileArchive,
    FileAxis3d,
    FileBadge,
    FileBox,
    FileBraces,
    FileBracesCorner,
    FileChartColumn,
    FileChartColumnIncreasing,
    FileChartLine,
    FileChartPie,
    FileCheck,
    FileCheckCorner,
    FileClock,
    FileCode,
    FileCodeCorner,
    FileCog,
    FileDiff,
    FileDigit,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "euro" through "file-digit", inclusive. */
const shard: Record<string, LucideIcon> = {
    euro: Euro,
    "ev-charger": EvCharger,
    expand: Expand,
    "external-link": ExternalLink,
    eye: Eye,
    "eye-closed": EyeClosed,
    "eye-dashed": EyeDashed,
    "eye-off": EyeOff,
    "face-angry": FaceAngry,
    "face-expressionless": FaceExpressionless,
    "face-grinning": FaceGrinning,
    "face-neutral": FaceNeutral,
    "face-slightly-frowning": FaceSlightlyFrowning,
    "face-slightly-smiling": FaceSlightlySmiling,
    "face-slightly-smiling-plus": FaceSlightlySmilingPlus,
    factory: Factory,
    fan: Fan,
    "fast-forward": FastForward,
    feather: Feather,
    fence: Fence,
    "ferris-wheel": FerrisWheel,
    file: File,
    "file-archive": FileArchive,
    "file-axis-3d": FileAxis3d,
    "file-badge": FileBadge,
    "file-box": FileBox,
    "file-braces": FileBraces,
    "file-braces-corner": FileBracesCorner,
    "file-chart-column": FileChartColumn,
    "file-chart-column-increasing": FileChartColumnIncreasing,
    "file-chart-line": FileChartLine,
    "file-chart-pie": FileChartPie,
    "file-check": FileCheck,
    "file-check-corner": FileCheckCorner,
    "file-clock": FileClock,
    "file-code": FileCode,
    "file-code-corner": FileCodeCorner,
    "file-cog": FileCog,
    "file-diff": FileDiff,
    "file-digit": FileDigit,
};

export default shard;
